module.exports = __webpack_public_path__ + "img/inProgress-open.202bbef2.png";